import { createSelector } from '@ngrx/store';
import { find } from 'lodash';

import { AuthSelectors } from '@lockton-apps/shared/data-access/auth';
import { ContactsSelectors } from '@lockton-apps/shared/data-access/contacts';
import { UserRouterSelectors } from '@lockton-apps/shared/data-access/router';
import { UsersSelectors } from '@lockton-apps/shared/data-access/users';
import { Role } from '@lockton-apps/shared/interfaces';

export const selectAuthenticatedUser = createSelector(
  AuthSelectors.getNameId,
  UsersSelectors.getAllUsers,
  (userId, allUsers) => allUsers.find((user) => user.userId === userId)
);

export const selectAuthenticatedContact = createSelector(
  AuthSelectors.getNameId,
  ContactsSelectors.getAllContacts,
  (userId, allContacts) =>
    allContacts.find((contact) => contact.userId === userId)
);

export const selectAuthenticatedContactFirstPrimaryClient = createSelector(
  selectAuthenticatedContact,
  (contact) =>
    find(contact?.clients, (client) => client.isPrimary) || contact?.clients[0]
);

export const selectAuthenticatedUserRole = createSelector(
  selectAuthenticatedUser,
  (user) => user?.role
);

export const selectAuthenticatedUserLanguage = createSelector(
  selectAuthenticatedUser,
  (user) => user?.language
);

export const selectHasMutateBrokerPermissions = createSelector(
  AuthSelectors.getRole,
  (role) => role === Role.Administrator || role === Role.LeadBroker
);

export const selectSelectedUserIsSelf = createSelector(
  AuthSelectors.getNameId,
  UsersSelectors.getSelectedId,
  (authUserId, selectedUserId) => authUserId === selectedUserId
);

export const selectRoutedUserIsSelf = createSelector(
  AuthSelectors.getNameId,
  UserRouterSelectors.selectRoutedId,
  (authUserId, routedUserId) => authUserId === routedUserId
);
